import Box from '@mui/material/Box/Box'
import Stack from '@mui/material/Stack/Stack'
import Typography from '@mui/material/Typography/Typography'

import { i18WithParams as t, i18WithComponent as tc } from '@shared/locale'
import { ButtonActions } from 'components-ui/src/button_actions/button_actions'
import { formatNumberAsPrice } from 'components-ui/src/shared/common'
import { SimpleModal } from 'components-ui/src/simple_modal/simple_modal'
import { Spacer } from 'components-ui/src/spacer/spacer'

interface Props {
  price: number | undefined
  strategy: string
  multiplePets?: boolean
  onClose: () => Promise<void>
  onConfirm: () => Promise<void>
}

const Underline = () => {
  return (
    <Typography component="span" variant="body2bold" sx={{ textDecoration: 'underline' }}>
      {t('global.label.not')}
    </Typography>
  )
}

export const WaitlistModal = ({ onClose, onConfirm, price, strategy, multiplePets = false }: Props) => {
  const priceParsed = formatNumberAsPrice(price)
  const priceStr = priceParsed ? `${priceParsed}/${strategy}` : t('searchResults.waitlist.price.unavailable')

  const description = multiplePets
    ? t('searchResults.waitlist.description.multiple')
    : t('searchResults.waitlist.description')

  return (
    <SimpleModal open={true} onClose={onClose} sx={{ width: 600 }}>
      <Typography variant="h5">{t('searchResults.waitlist.title')}</Typography>
      <Typography variant="body2bold" color="error">
        {tc('searchResults.waitlist.lead', { not: <Underline /> })}
      </Typography>

      <Spacer height={2} />

      <Typography variant="body1" gutterBottom>
        {description}
      </Typography>

      <Spacer height={2} />

      <Box sx={{ border: '1px solid #ddd', borderRadius: '8px', p: 2 }}>
        <Typography variant="body2bold">
          {t('searchResults.waitlist.price')}: {priceStr}
        </Typography>
        <Typography variant="subtitle2" color="text.secondary">
          {t('searchResults.waitlist.price.note')}
        </Typography>
      </Box>

      <Spacer height={2} />

      <Stack direction="row" justifyContent="end">
        <ButtonActions
          onActionLabel={t('searchResults.waitlist.actionButton')}
          onAction={onConfirm}
          onCancel={onClose}
        />
      </Stack>
    </SimpleModal>
  )
}
